var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"comments__comments-list"},_vm._l((_vm.comments),function(comment,index){return _c('comment-item',{key:index,attrs:{"comment":comment,"source_id":_vm.source_id},on:{"load":function($event){return _vm.$emit('load')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }